export default __webpack_public_path__ + "static/media/granola_parfait.0d159413.jpg";